import { capitalCase } from 'change-case-all';

export const trackedMxEvents: string[] = [
  'connected',
  'createMemberError',
  'loaded',
  'memberConnected',
  'oauthError',
  'oauthRequested',
  'selectedInstitution',
];

export const formatMXEvents = (type: string, list: string[] = trackedMxEvents): string | null => {
  const mxEvent = type.replace(/mx\/connect\//, '');

  return list.includes(mxEvent) ? capitalCase(mxEvent) : null;
};
